// Loosely validates that a string could be a Finnish vehicle registration number
// before spending a (metered) external vehicle lookup on it. The
// biluppgifter / rekisterinumeroapi providers are the source of truth and 404
// (negative-cached) on anything they don't recognise; this gate only blocks
// empty / obviously-non-plate input. Requires at least one letter.
//
// Normalizing away spaces and hyphens means both "ABC-123" and "ABC123" pass, and
// non-standard plates (e.g. "48LCT", export/test plates) are accepted too.
export function isFinnishRegistrationNumber(regNumber) {
  if (!regNumber) return false;
  const normalized = regNumber.replace(/[\s-]/g, '').toUpperCase();
  return /^(?=.*[A-Z])[A-Z0-9]{2,7}$/.test(normalized);
}
